import classNames from "classnames/bind";
import styles from "./Car.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Grid, Lazy, FreeMode } from "swiper";
import { Link } from "react-router-dom";
import {
    faAngleRight,
    faAnglesLeft,
    faArrowLeft,
    faBars,
    faBoltLightning,
    faCarRear,
    faCarSide,
    faCircleInfo,
    faGaugeHigh,
    faGears,
    faImage,
    faMagnifyingGlass,
} from "@fortawesome/free-solid-svg-icons";
import React, { useEffect, useRef } from "react";
import CarSlider from "~/components/Car/CarSlider/CarSlider";
import { Helmet } from "react-helmet";
// import BreadCrumb from "~/components/BreadCrumb/BreadCrumb";
import Brands from "~/Data/Brands";
import BreadCrumb from "~/components/BreadCrumb/BreadCrumb";
import AllCar from "~/Data";
import { faSuperpowers } from "@fortawesome/free-brands-svg-icons";
import Para from "~/components/Car/Para/Para";
import Commnet from "~/components/Comment/Commnet";
import SideBrands from "~/components/Brands/SideBrands/SideBrands";
import Compare from "~/components/Car/Compare/Compare";
import { handleHistoryView } from "~/hooks/function";
import { CarsInBrand } from "~/Data/CarsInBrand";
import SideBlog from "~/components/SideBlog";
import BlogSlide from "~/components/BlogSlide/BlogSlide";
const cx = classNames.bind(styles);
function Car({ data }) {
    console.log("carrrrrrrrrrr");
    const header = document.getElementsByTagName("header");
    const head = document.getElementsByClassName(cx("head"));
    setTimeout(() => {
        header[0].classList.add(cx("ontop"));
        head[0].classList.remove(cx("ontop1"));
    });
    let lastScrollTop = 0;
    const handleScroll = (e) => {
        var st = window.pageYOffset || document.documentElement.scrollTop;
        if (window.scrollY < 50) {
            header[0].classList.add(cx("ontop"));
            head[0].classList.remove(cx("ontop1"));
        }

        if (st > lastScrollTop) {
            if (window.scrollY > 200) {
                header[0].classList.add(cx("ontop"));
                head[0].classList.add(cx("ontop1"));
            }
        } else {
            if (window.scrollY > 50) {
                header[0].classList.remove(cx("ontop"));
            }
            // else {
            //     header[0].classList.remove(cx("ontop"));
            // }
        }
        lastScrollTop = st <= 0 ? 0 : st;
    };
    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
            header[0].classList.remove(cx("ontop"));
        };
    }, []);
    const inBrand = CarsInBrand[data.brand.replace(" ", "")];
    let showInBrands = inBrand.filter((i) => i.name !== data.name);
    showInBrands = showInBrands.splice(0, 3);
    console.log(inBrand.length);
    window.scrollTo(0, 0);
    let brand = Brands.filter((e) => e.brand === data.brand);
    const mediaQuery = window.matchMedia("(min-width: 768px)").matches;
    brand = brand[0];
    const contentRef = useRef();
    const commentRef = useRef();
    const reviewRef = useRef();

    setTimeout(() => {
        reviewRef.current && (reviewRef.current.innerHTML = data.review);
    }, 0);
    const handleMore = () => {
        contentRef.current.scrollIntoView({
            behavior: "smooth",
            block: "start",
        });
    };
    let same = AllCar.filter(
        (i) =>
            i.para.priceus.replace(",", "") * 1 -
                data.para.priceus.replace(",", "") * 1 <
                20000 ||
            i.para.priceus.replace(",", "") * 1 -
                data.para.priceus.replace(",", "") * 1 >
                -20000
    );
    mediaQuery && (same = same.splice(0, 4));
    !mediaQuery && (same = same.splice(0, 6));
    return (
        <div className={cx("wrapper")}>
            {!mediaQuery && (
                <div className={cx("head", "ontop1")}>
                    <i
                        onClick={() => {
                            window.history.go(-1);
                        }}
                    >
                        <FontAwesomeIcon icon={faArrowLeft} />
                    </i>
                    <span>
                        {data.brand} {data.name}
                    </span>
                    <b>
                        <FontAwesomeIcon icon={faBars} />
                    </b>
                </div>
            )}
            <Compare data={data} />
            {mediaQuery && (
                <div className={cx("bread_crumb")}>
                    <BreadCrumb data={data} brand={brand} />
                </div>
            )}

            <Helmet>
                <title>
                    {data.name} - Thông số chi tiết. Giá công bố - Giá lăn bánh
                    Việt Nam
                </title>
                <meta
                    name="description"
                    content={`Tốc độ tối đa, Động cơ, Hộp số Giá công bố, giá về Việt Nam của ${data.name} cập nhật`}
                />
                <meta
                    name="keywords"
                    content={`thông số ${data.name}, vũ trụ siêu xe, giá ${data.name}, đánh giá ${data.name}, ${data.name} về Việt Nam`}
                />
            </Helmet>
            <div className={cx("top")}>
                <div className={cx("slide_wrapper")}>
                    <CarSlider />
                    {mediaQuery && (
                        <>
                            <div className={cx("price_wrap")}>
                                <div>
                                    <span>Giá công bố</span>
                                    <p>{data.para.priceus || "-"} USD</p>
                                </div>
                                <div>
                                    <span>Giá về Việt Nam</span>
                                    <p>{data.para.pricevn || "-"} VND</p>
                                </div>
                            </div>
                            <span className={cx("price")}>
                                <FontAwesomeIcon icon={faCircleInfo} /> &nbsp;
                                Giá chênh lệch do tỷ giá khác thời điểm hoặc có
                                thuế đặc biệt nếu xe về Việt Nam
                            </span>
                        </>
                    )}
                </div>
                <div className={cx("detail_wrapper")}>
                    <div className={cx("brand")}>
                        <div className={cx("limited")}> Xe sang&nbsp; </div>
                        {!mediaQuery && (
                            <div
                                className={cx("back")}
                                onClick={() => window.history.go(-1)}
                            >
                                {" "}
                                <FontAwesomeIcon icon={faArrowLeft} />
                            </div>
                        )}
                        <Link className={cx("logo")} to={brand.path}>
                            <img src={brand.avatar} alt=""></img>
                        </Link>
                    </div>
                    <div className={cx("info")}>
                        <h2>
                            {data.brand} {data.name}
                        </h2>
                        <div className={cx("para")}>
                            <div>
                                <div>
                                    <span>
                                        <FontAwesomeIcon icon={faCarRear} />
                                    </span>{" "}
                                    <span>Loại</span>
                                </div>
                                <h5>{data.type || "-"}</h5>
                            </div>{" "}
                            <div>
                                <div>
                                    <span>
                                        <FontAwesomeIcon icon={faGears} />
                                    </span>{" "}
                                    <span>Động cơ</span>
                                </div>
                                <h5>{data.engine || "-"}</h5>
                            </div>{" "}
                            <div>
                                <div>
                                    <span>
                                        <FontAwesomeIcon icon={faCarSide} />
                                    </span>{" "}
                                    <span>Kích thước</span>
                                </div>
                                <h5>{data.para.size}</h5>
                            </div>{" "}
                            <div>
                                <div>
                                    <span>
                                        <FontAwesomeIcon icon={faGaugeHigh} />
                                    </span>{" "}
                                    <span>Tốc độ tối đa</span>
                                </div>
                                <h5>{data.max || "-"} Km/h</h5>
                            </div>{" "}
                            <div>
                                <div>
                                    <span>
                                        <FontAwesomeIcon
                                            icon={faBoltLightning}
                                        />
                                    </span>{" "}
                                    <span>Tăng tốc 100 Km</span>
                                </div>
                                <h5>{data.para.max100 || "-"} giây</h5>
                            </div>
                            <div>
                                <div>
                                    <span>
                                        <FontAwesomeIcon icon={faSuperpowers} />
                                    </span>{" "}
                                    <span>Công suất cực đại</span>
                                </div>
                                <h5>{data.para.watt || "-"}</h5>
                            </div>{" "}
                        </div>
                        {mediaQuery && (
                            <div className={cx("more_para")}>
                                <p onClick={handleMore}>Xem thêm thông số</p>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <div ref={contentRef} className={cx("margin")}></div>
            <div className={cx("content")}>
                <div className={cx("main")}>
                    <Para data={data} />
                    <div ref={reviewRef} className={cx("review")}></div>
                    <div className={cx("comment_box")} ref={commentRef}>
                        <h3>Bình luận</h3>
                        <Commnet data={data} />
                    </div>
                </div>

                <div className={cx("side")}>
                    <div>
                        <h3>Cạnh tranh</h3>
                        {!mediaQuery && (
                            <div className={cx("wrapper_swiper")}>
                                <Swiper
                                    slidesPerView={5}
                                    lazy={true}
                                    freeMode={true}
                                    grid={{
                                        rows: 1,
                                    }}
                                    pagination={{
                                        dynamicBullets: true,
                                    }}
                                    modules={[Grid, Lazy, Pagination, FreeMode]}
                                    breakpoints={{
                                        "@0.00": {
                                            slidesPerView: 2.6,
                                            pagination: false,
                                        },
                                        "@1.25": {
                                            slidesPerView: 4,
                                        },
                                        "@1.5": {
                                            slidesPerView: 5,
                                        },
                                    }}
                                    className={cx("swiper")}
                                >
                                    {" "}
                                    {same.map((car, index) => (
                                        <SwiperSlide
                                            key={index}
                                            className={cx("swiper_item")}
                                        >
                                            <Link
                                                onClick={() =>
                                                    handleHistoryView(car)
                                                }
                                                className={cx(
                                                    "swiper_item-link"
                                                )}
                                                to={car.link}
                                            >
                                                <img
                                                    className={cx(
                                                        "swiper-lazy"
                                                    )}
                                                    loading="lazy"
                                                    src={car.avatar}
                                                    alt={car.name}
                                                    // onClick={(e) => handleClick(car)}
                                                />

                                                <div>
                                                    <h4>{car.name}</h4>
                                                    <div
                                                        className={cx(
                                                            "car_info"
                                                        )}
                                                    >
                                                        <p>
                                                            {" "}
                                                            {car.brand}{" "}
                                                            <span>
                                                                {car.price} Tỷ{" "}
                                                            </span>
                                                        </p>{" "}
                                                    </div>
                                                </div>
                                            </Link>
                                        </SwiperSlide>
                                    ))}
                                </Swiper>
                            </div>
                        )}
                        {mediaQuery && (
                            <div className={cx("side_wrapper")}>
                                {same.map((item, id) => {
                                    return (
                                        <Link
                                            onClick={() =>
                                                handleHistoryView(item)
                                            }
                                            to={item.link}
                                            key={id}
                                            className={cx("side_item")}
                                        >
                                            <img
                                                src={item.avatar}
                                                alt={`Xe ${item.brand} ${item.name} `}
                                            />
                                            <div>
                                                <p>{item.name}</p>
                                                <p>{item.brand}</p>
                                            </div>
                                            <i>
                                                <FontAwesomeIcon
                                                    icon={faAngleRight}
                                                />
                                            </i>
                                        </Link>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                    {!mediaQuery && (
                        <div className={cx("side_blog")}>
                            <h3>Tin liên quan</h3>
                            <BlogSlide />
                        </div>
                    )}
                    {inBrand.length - 1 > 1 && (
                        <div className={cx("side_item")}>
                            <h3>Cùng hãng {data.brand}</h3>
                            <div className={cx("side_wrapper")}>
                                {showInBrands.map((item, id) => {
                                    return (
                                        <Link
                                            onClick={() =>
                                                handleHistoryView(item)
                                            }
                                            to={item.link}
                                            key={id}
                                            className={cx("side_item")}
                                        >
                                            <img
                                                src={item.avatar}
                                                alt={`Xe ${item.brand} ${item.name} `}
                                            />
                                            <div>
                                                <p>{item.name}</p>
                                                <p className={cx("side_same")}>
                                                    <span>
                                                        {item.max} Km/h{" "}
                                                    </span>
                                                    <span>
                                                        {" "}
                                                        {item.price} Tỷ{" "}
                                                    </span>
                                                </p>
                                            </div>

                                            <i>
                                                <FontAwesomeIcon
                                                    icon={faAngleRight}
                                                />
                                            </i>
                                        </Link>
                                    );
                                })}
                            </div>
                            <Link
                                to={`/brands/${inBrand[0].brand
                                    .toLowerCase()
                                    .replace(" ", "-")}`}
                                className={cx("brand_more")}
                            >
                                Xem tất cả {inBrand.length} dòng xe của{" "}
                                {inBrand[0].brand}
                            </Link>
                        </div>
                    )}
                    {mediaQuery && (
                        <div className={cx("side_blog")}>
                            <h3>Tin liên quan</h3>
                            <SideBlog />
                        </div>
                    )}
                    {!mediaQuery && <h3>Các hãng xe khác</h3>}
                </div>
                {!mediaQuery && <SideBrands />}
            </div>
            {!mediaQuery && (
                <div className={cx("bread_crumb")}>
                    <BreadCrumb data={data} brand={brand} />
                </div>
            )}
        </div>
    );
}

export default Car;
